// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"546":"088f5dd4","921":"2ebc8711"}[chunkId] + ".chunk.js";
};